import React from 'react';

import {
    FormInputFieldWrapper,
    FormFieldWrapperProps,
} from 'app/components/common/inputs/common/input/form-input-field-wrapper';

import { QuantityInput, Props as QuantityInputProps } from './quantity-input';

const FormQuantityInput: React.FC<FormFieldWrapperProps<QuantityInputProps>> = (
    props: FormFieldWrapperProps<QuantityInputProps>,
) => <FormInputFieldWrapper {...props} component={QuantityInput} />;

export { FormQuantityInput };
